<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-food"></i> 食材物资</span>
      </div>

      <!-- 查询区域 -->
      <el-form
        :model="queryParams"
        :inline="true"
        label-position="right"
        style="margin-bottom: 20px"
      >
        <el-form-item label="物资类别">
          <el-select
            v-model="queryParams.materialType"
            placeholder="请选择物资类别"
            clearable
            style="width: 250px"
          >
            <el-option
              v-for="item in categoryOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="物资名称">
          <el-input
            v-model="queryParams.name"
            placeholder="请输入物资名称"
            clearable
            style="width: 250px"
          />
        </el-form-item>
        <el-row>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleQuery(1)"
            >搜索</el-button
          >
          <el-button @click="resetQuery">重置</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="openAddDialog"
            >新增</el-button
          >
        </el-row>
      </el-form>

      <!-- 表格区域 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
      >
        <el-table-column label="物资类别" prop="materialTypeName" />
        <el-table-column label="物资名称" prop="name" />
        <el-table-column label="单位" prop="unit" />
        <el-table-column label="创建时间" prop="createTime" />
        <el-table-column label="创建人" prop="creatorName" />
        <el-table-column label="操作" width="150">
          <template v-slot="scope">
            <el-button size="mini" @click="openEditDialog(scope.row)"
              >编辑</el-button
            >
            <el-button size="mini" type="danger" @click="deleteItem(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <pagination-bar
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @update:pageSize="pageSize = $event"
        @update:currentPage="currentPage = $event"
        @page-change="handleQuery"
      />

      <!-- 弹窗表单 -->
      <el-dialog
        :visible.sync="dialogVisible"
        :title="isEdit ? '编辑物资' : '新增物资'"
        width="500px"
        @close="resetForm"
         :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form
          :model="formData"
          ref="form"
          :rules="rules"
          label-width="100px"
        >
          <el-form-item label="物资类别" prop="materialType">
            <el-select
              v-model="formData.materialType"
              placeholder="请选择物资类别"
              style="width: 350px"
            >
              <el-option
                v-for="item in categoryOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="物资名称" prop="name">
            <el-input
              v-model="formData.name"
              placeholder="请输入物资名称"
              style="width: 350px"
            />
          </el-form-item>
          <el-form-item label="单位" prop="unit">
            <el-input
              v-model="formData.unit"
              placeholder="请输入单位"
              style="width: 350px"
            />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveData">
            {{ isEdit ? "更新" : "确定" }}
          </el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import {
  foodMaterialList,
  foodMaterialAddOrEdit,
  foodMaterialDelete,
} from "@/api/config";
import { assetsCategoryPage } from "@/api/material";
import { MAX_PAGE_SIZE } from "@/utils/const.js";

import PaginationBar from "@/components/PaginationBar";

export default {
  components: { PaginationBar },
  data() {
    return {
      queryParams: {
        materialType: "",
        name: "",
      },
      categoryOptions: [],
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      formData: {
        materialType: "",
        name: "",
        unit: "",
      },
      isEdit: false,
      rules: {
        materialType: [
          { required: true, message: "请选择物资类别", trigger: "change" },
        ],
        name: [{ required: true, message: "请输入物资名称", trigger: "blur" }],
        unit: [{ required: true, message: "请输入单位", trigger: "blur" }],
      },
    };
  },
  created() {
    this.handleQuery();
    this.getFoodTypes();
  },
  methods: {
    // 请求食材物资的分类
    getFoodTypes() {
      assetsCategoryPage({
        pageNo: 1,
        pageSize: MAX_PAGE_SIZE,
        category: "食材物资",
      }).then((res) => {
        this.categoryOptions = res.records;
        console.log(this.categoryOptions.map((item) => typeof item.name));

        console.log("res", res, this.categoryOptions);
      });
    },
    resetForm() {
      // 重置表单及校验状态
      this.$refs.form.resetFields();
    },
    handleQuery(page) {
      this.currentPage = page || 1;
      foodMaterialList({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        ...this.queryParams,
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    resetQuery() {
      this.queryParams = { materialType: "", name: "" };
      this.currentPage = 1;
      this.handleQuery();
    },
    openAddDialog() {
      this.isEdit = false;
      this.formData = { materialType: "", name: "", unit: "" };
      this.dialogVisible = true;
    },
    openEditDialog(row) {
      this.isEdit = true;
      this.formData = { ...row };
      this.dialogVisible = true;
    },
    saveData() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        const params = { ...this.formData };
        foodMaterialAddOrEdit(params).then(() => {
          this.dialogVisible = false;
          this.handleQuery();
          this.$message.success("操作成功");
        });
      });
    },
    deleteItem(row) {
      this.$confirm("确定删除此物资？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        // 删除逻辑
        foodMaterialDelete({ id: row.id }).then(() => {
          this.$message.success("删除成功！");
          this.handleQuery();
        });
      });
    },
  },
};
</script>

<style scoped>
.app-container {
}
.dialog-footer {
  text-align: right;
}
</style>
